import * as React from 'react';
import {ForwardedRef, useImperativeHandle} from 'react';
import {ViewerEvent} from '../events';
import {mapDefaultProps, MapProps, mapPropTypes, viewerDefaultProps, ViewerProps, viewerPropTypes} from '../props';
import {BaseMapViewer} from './BaseMapViewer';
import {useBaseProps} from '../hooks';
import {createViewerActions, ViewerActions} from '../actions';
import {createMapActions, MapActions} from '../actions/MapActions';

/**
 * Properties mapového zobrazovače.
 */
export type MapViewerProps = MapProps<ViewerEvent> & ViewerProps;

/**
 * Akce mapového zobrazovače.
 */
export type MapViewerActions = MapActions & ViewerActions;

/**
 * React komponenta mapového zobrazovače.
 *
 * - Properties: {@link MapViewerProps}.
 * - Ref: {@link MapViewerActions}.
 */
export const MapViewer = React.forwardRef(
    (props: MapViewerProps, ref: ForwardedRef<MapViewerActions>): JSX.Element => {
        const baseProps = useBaseProps();
        useImperativeHandle(ref, () => ({
            ...createMapActions(baseProps.frameDispatch),
            ...createViewerActions(baseProps.frameDispatch),
        }));
        return <BaseMapViewer {...props} {...baseProps} />;
    },
);

/**
 * Zobrazované jméno.
 */
MapViewer.displayName = 'MapViewer';

/**
 * Typy properties.
 */
MapViewer.propTypes = {
    ...mapPropTypes,
    ...viewerPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
MapViewer.defaultProps = {
    ...mapDefaultProps,
    ...viewerDefaultProps,
};
